import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/data/data.js";
import "./swgfl/javascript/accessibility.js";
import cookies from "./swgfl/cookies/javascript/cookies.js";
import cms from "./swgfl/cms/javascript/cms.js";
import forms from "./swgfl/forms/javascript/forms.js";
import security from "./swgfl/security/javascript/all.js";
import faqs from "./swgfl/faqs/javascript/faqs.js";
import "./swgfl/articles/javascript/whatsapp.js";
import survey from "./website/javascript/survey.js";
import chatbot from "./swgfl/chatbot/javascript/chatbot.js";
import "./swgfl/report/javascript/report.js";
import map from "./swgfl/javascript/map.js";
import gtm from "./swgfl/javascript/google-tag-manager.js";
import crm from "./crm/javascript/all.js";
// import cannedResponses from "./crm/javascript/cannedresponses.js";

$(() => {
	cookies($(".cookies"));
	cms($("#form-cms"));
	forms();
	security();
	faqs($(".faqs"));
	survey($(".survey__switch"));
	chatbot($(".chatbot[data-chatbot]"));
	map($("[data-map]"));
	crm();
	gtm($("html").data("gtm"));
	// cannedResponses();
});
